import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, useManualQuery, ClientContext } from "graphql-hooks";
import { useNavigate } from "react-router-dom";
import { seo_tag_config,FROM_DEFAULT, project_url} from "../../constants/Data";

import {
  Card,
  CardContent,
  Container,
  Button,
  Typography,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";

import { GET_TERM_DATA_BY_TERM_UUID } from "../../graphQL/term_qry";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    paddingBottom: 80,
    paddingTop: 100,
    maxWidth: 806,
    minHeight: 468,
  },
  cardContainerTablet: {
    paddingBottom: 38,
    paddingTop: 68,
    paddingLeft: 48,
    paddingRight: 48,
    maxWidth: 750,
    height: 468,
  },
  cardTablet: {
    display: "flex",
    flexDirection: "column",
    minHeight: 250,
  },
  cardContent: {
    padding: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    minHeight: 250,
  },
  cardContentTablet: {
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    minHeight: 250,
  },
  cardMobile: {
    display: "flex",
    flexDirection: "column",
    minHeight: 250,
  },
  cardContentMobile: {
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    paddingTop: 90,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    fontSize: 16,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
}));

const SubmittedForm = () => {
  const { termUuid } = useParams();
  const classes = useStyles();
  const [state, setState] = useState({
    mobileView: false,
    tabletView: false,
  });
  const navigate = useNavigate();
  const [applicantEmail, setApplicantEmail] = useState("");
  const [applicantName, setApplicantName] = useState("");
  const [tenantName, setTenantName] = useState("");
  const [termName, setTermName] = useState("");
  const [termStartDate, setTermStartDate] = useState("");
  const [tenantContactEmail, setTenantContactEmail] = useState("");
  const [applicantStatus, setApplicantStatus] = useState("");
  const { mobileView, tabletView } = state;

  const from_default = FROM_DEFAULT;
  
  const [getTermInfo] = useManualQuery(GET_TERM_DATA_BY_TERM_UUID, {
    fetchPolicy: "network-only",
  });
  
    
  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  });
  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    console.log(dayFormat);
    const newFormat =
      dayFormat.find(a => a.type == "month").value +
      " " +
      dayFormat.find(a => a.type == "day").value +
      ", " +
      dayFormat.find(a => a.type == "year").value;
    return newFormat;
  };
  
  const getTermData = async () => {
    const {
        loading: termInfoLoading,
        error: termInfoError,
        data: termInfo,
      } = await getTermInfo({
        variables: { termUuid: termUuid },
      });
    if (!termInfoLoading && termInfo && termInfo.getTermDataByTermUuid) {
        setTermName(termInfo.getTermDataByTermUuid.name);
        setTermStartDate(dayFormat(termInfo.getTermDataByTermUuid.startDate));
        setTenantName(termInfo.getTermDataByTermUuid.formId.clientId.tenantId.name);        
        setTenantContactEmail(termInfo.getTermDataByTermUuid.formId.clientId.tenantId.contactEmail);        
    }
    
    if (
        termInfoError &&
        termInfoError.graphQLErrors &&
        termInfoError.graphQLErrors[0].message === "Term matching query does not exist."
    ) {
        alert("Are you sure you have valid URL?");
    }
  }
  
  useEffect(() => {
    (() => getTermData())();
    
  }, [termUuid]);

  useEffect(() => {
    
    const setResponsiveness = () => {
      return window.innerWidth < 768
        ? setState(() => ({ mobileView: true }))
        : window.innerWidth < 821 && window.innerWidth > 767
        ? setState(() => ({ mobileView: false, tabletView: true }))
        : setState(() => ({ tabletView: false }));
    };
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());
    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);
  
  useEffect(() => { 

    setApplicantEmail(localStorage.getItem("applicantEmail"));
    setApplicantName(localStorage.getItem("applicantName"));
    setApplicantStatus(localStorage.getItem("applicantStatus"));
    setTenantName(localStorage.getItem("tenantName"));

    
  }, [localStorage]);
  
  const EmailLink = ({ tenantContactEmail }) => {
    return <a href={`mailto:${tenantContactEmail}`} target="_self">{tenantContactEmail}</a>;
  }
  console.log('applicantStatus',applicantStatus)
  return (
    <>
      <title>APIE | Submit Form</title>
      {/*userEmailAddress && */ mobileView && (
        <Card className={classes.cardMobile}>
          <CardContent className={classes.cardContentMobile}>
          <Box alignItems="center" mb={3} flexGrow={1}>
            <Box textAlign="center">
                  <Typography variant="subtitle1">
                    Hi, {applicantName}
                  </Typography>
                </Box>
                <Typography variant="body1">
                  It seems you have already applied for volunteering with { tenantName } with the email address you provided.                  
                  <br />
                  <br />
                  <Box textAlign="center">Your email address is:</Box>
                </Typography>
                <Box textAlign="center">
                  <Typography
                    variant="body1"
                    style={{ fontSize: 20, fontWeight: 600 }}
                  >
                    {applicantEmail}
                  </Typography>
                </Box>
                <Typography variant="body1">
                  <br />
                  If this is the first time you apply at ASVPM and you believe there is an error, 
                  contact <EmailLink tenantContactEmail={tenantContactEmail} /> and we will do resolve the issue.
                  <br />
                  <br />
                </Typography>
          </Box>
          </CardContent>
        </Card>
      )}
      {/*userEmailAddress && */ tabletView && (
        <Container className={classes.cardContainerTablet} maxWidth="sm">
          <Card className={classes.cardTablet}>
            <CardContent className={classes.cardContentTablet}>
            <Box alignItems="center" mb={3} flexGrow={1}>
              <Box textAlign="center">
                  <Typography variant="subtitle1">
                    Hi, {applicantName}
                  </Typography>
                </Box>
                <Typography variant="body1">
                  It seems you have already applied for volunteering with { tenantName } with the email address you provided.                  
                  <br />
                  <br />
                  <Box textAlign="center">Your email address is:</Box>
                </Typography>
                <Box textAlign="center">
                  <Typography
                    variant="body1"
                    style={{ fontSize: 20, fontWeight: 600 }}
                  >
                    {applicantEmail}
                  </Typography>
                </Box>
                <Typography variant="body1">
                  <br />
                  If this is the first time you apply at ASVPM and you believe there is an error, 
                  contact <EmailLink tenantContactEmail={tenantContactEmail} /> and we will do resolve the issue.
                  <br />
                  <br />
                </Typography>
            </Box>
            </CardContent>
          </Card>
        </Container>
      )}
      {/*userEmailAddress && */ !mobileView && !tabletView && (
        <Container className={classes.cardContainer} maxWidth="sm">
          <Card style={{ display: "flex", flexDirection: "row" }}>
            <CardContent className={classes.cardContent}>
              <Box alignItems="center" mb={3} flexGrow={1}>
                <Box textAlign="center">
                  <Typography variant="subtitle1">
                    Hi, {applicantName}
                    {(applicantStatus === "New" || applicantStatus === "NewForThisClient") && (
                      <>
                        <br />
                        Welcome to {tenantName}
                      </>
                    )}

                    {(applicantStatus === "Returning" || applicantStatus === "ApplyNextTerm") && (
                      <>
                        <br />
                        Welcome back to {tenantName}
                      </>
                    )}
                  </Typography>
                </Box>
                
                {applicantStatus === "New" && (
                    <>
                       <Typography variant="body1">

                        A user account is created for you. 
                        <br />
                        You will receive an email from <a href={`mailto:${from_default}`} target="_self">
                        {from_default}
                        </a>.
                        <br />
                        Thank you for applying for volunteering with { tenantName } for sprint { termName } that starts on { termStartDate }.

                        Your application will be reviewed and you will be notified before start of the new sprint. 
                        <br />
                        <br />
                        
                        <Box textAlign="center">We sent the email to:</Box>
                      </Typography>
                      <Box textAlign="center">
                        <Typography
                          variant="body1"
                          style={{ fontSize: 20, fontWeight: 600 }}
                        >
                          {applicantEmail}
                        </Typography>
                      </Box>
                      <Typography variant="body1">
                        <p>
                        Please check your inbox. To activate your account, confirm your email address by clicking the link in the email we sent you.
                        </p>
                        <p>
                        If you did not see the email in your inbox, check your spambox. You should have received an email from <a href={`mailto:${from_default}`} target="_self">
                        {from_default}
                        </a>. 
                        </p>
                        <p>
                        If you still cannot find the email, 
                        contact <EmailLink tenantContactEmail={tenantContactEmail} /> and we will help you activate your account.
                        </p>
                        
                      </Typography>
                      </>  
                )}

                {applicantStatus === "NewForThisClient" && (
                    <>
                       <Typography variant="body1">
                        You already have a user account. 
                        <br />
                        You will receive an email from <a href={`mailto:${from_default}`} target="_self">
                        {from_default}
                        </a>.
                        <br />
                        Thank you for applying for volunteering with  { tenantName } for sprint { termName } that starts on { termStartDate }. 

                        Your application will be reviewed and you will be notified before start of the new sprint.
                        <br />
                        <br />
                        
                        <Box textAlign="center">We sent the email to:</Box>
                      </Typography>
                      <Box textAlign="center">
                        <Typography
                          variant="body1"
                          style={{ fontSize: 20, fontWeight: 600 }}
                        >
                          {applicantEmail}
                        </Typography>
                      </Box>
                      <Typography variant="body1">
                        <p>
                        Please check your inbox. To sign in to your account, click the link in the email we sent you.
                        </p>
                        <p>
                        If you did not see the email in your inbox, check your spambox. You should have received an email from <a href={`mailto:${from_default}`} target="_self">
                        {from_default}
                        </a>. 
                        </p>
                        <p>
                        If you still cannot find the email, contact <EmailLink tenantContactEmail={tenantContactEmail} /> and we will help you resolve the issue.
                        </p>
                      </Typography>
                      </>  
                )}

                {applicantStatus === "Duplicate" && (
                     
                    <>
                        <Typography variant="body1">
                        It seems you already applied for volunteering with { tenantName } for sprint { termName } that started on { termStartDate } with the email address you provided.                        
                        <br />
                        <br />                        
                        <Box textAlign="center">Your email address is:</Box>
                        </Typography>
                        <Box textAlign="center">
                          <Typography
                            variant="body1"
                            style={{ fontSize: 20, fontWeight: 600 }}
                          >
                            {applicantEmail}

                          </Typography>
                        </Box>

                        <br />
                        <Typography variant="body1">
                        You do not need to apply again. Instead, you should sign in to your account.
                        </Typography>

                        <Typography variant="body1">
                          <br />
                          If you believe this is the first time you apply at {tenantName} and the message may be an error, contact 
                           <EmailLink tenantContactEmail={tenantContactEmail} /> and we will resolve the issue.
                          <br />
                          <br />
                         </Typography>
                    </> 
                )}
                    
                {applicantStatus === "TenantUser"  && ( 
                    <>
                        <Typography variant="body1">
                            The email address you used is {applicantEmail}. 
                            <br />
                            This email address is not allowed. Please use your personal email address to complete the volunteer form.
                                                  
                                
                            <br />                  
                        </Typography>
                              
                        <Typography variant="body1">
                            <br />
                            If you believe this is the first time you apply at {tenantName} and the message may be an error, contact 
                           <EmailLink tenantContactEmail={tenantContactEmail} /> and we will resolve the issue.
                            <br />
                            <br />
                        </Typography>
                    </>
                )}
                        
                {applicantStatus === "Active" && (
                            
                    <>
                        <Typography variant="body1">
                          It seems you already applied for volunteering with { tenantName } for sprint { termName } that started on { termStartDate } with the email address you provided.                          
                          <br />
                          <br />
                          <Box textAlign="center">Your email address is:</Box>
                        </Typography>
                        <Box textAlign="center">
                          <Typography
                              variant="body1"
                              style={{ fontSize: 20, fontWeight: 600 }}
                          >
                            {applicantEmail}
                          </Typography>
                        </Box>
                        <br />
                        <Typography variant="body1">
                        You do not need to apply again. Instead, you should sign in to your account.
                        </Typography>
                        <Typography variant="body1">
                          <br />
                          If you believe this is the first time you apply at {tenantName} and the message may be an error, contact 
                           <EmailLink tenantContactEmail={tenantContactEmail} /> and we will resolve the issue.
                          <br />
                          <br />
                        </Typography>
                    </>
                )}
                            
                {(applicantStatus === "Returning" || applicantStatus === "ApplyNextTerm")  && (
                               
                    <> 
                      <Typography variant="body1">

                        Welcome back to the { tenantName } for sprint { termName } that starts on { termStartDate } 
                        with the email address you provided. 
                        <br />
                        <br />
                        
                        <Box textAlign="center">Your email address is:</Box>
                      </Typography>
                      <Box textAlign="center">
                        <Typography
                          variant="body1"
                          style={{ fontSize: 20, fontWeight: 600 }}
                        >
                          {applicantEmail}
                        </Typography>
                      </Box>
                      <Typography variant="body1">
                          <br />
                          If you believe this is the first time you apply at {tenantName} and the message may be an error, contact 
                           <EmailLink tenantContactEmail={tenantContactEmail} /> and we will resolve the issue.
                          <br />
                          <br />
                        </Typography>
                      </>  
                  
              )}

              {applicantStatus === "Not-Implemented"  && (
                 <Typography variant="body1"> Not Implemented - TBD </Typography>)}
              
              </Box>
            </CardContent>
          </Card>
        </Container>
      )}
    </>
  );
};

export default SubmittedForm;
